import { ButtonIcon, Tooltip, UpIcon } from 'canoe';
import React from 'react';

import { LogicRulesNames } from '@candu-ai/segments/types';
import { useToggle } from 'commons/hooks';
import { FormikFieldSetter } from 'craft/types';

import { SetContainsRuleUploadDialog } from './SetContainsRuleUploadDialog';

interface UploadButtonProps {
  base: string;
  setFieldValue: FormikFieldSetter;
  operationType?: LogicRulesNames;
}

export const UploadButton = ({ base, setFieldValue, operationType }: UploadButtonProps) => {
  const [open, toggle] = useToggle(false);

  return (
    <>
      <Tooltip placement="top" content="Upload CSV">
        <ButtonIcon icon={UpIcon} aria-label="Upload CSV" onClick={toggle} mt="xxs" />
      </Tooltip>
      {open && (
        <SetContainsRuleUploadDialog
          toggle={toggle}
          base={base}
          setFieldValue={setFieldValue}
          operationType={operationType}
        />
      )}
    </>
  );
};
